export default {
  ERROR: "ERROR",
  ERROR_RESET: "ERROR_RESET",
  GET_MONETIZATION_REPORT_REQUEST: "GET_MONETIZATION_REPORT_REQUEST",
  GET_MONETIZATION_REPORT_RECEIVE: "GET_MONETIZATION_REPORT_RECEIVE",
  GET_MONETIZATION_REPORT_ERROR: "GET_MONETIZATION_REPORT_ERROR"
};
